export default __webpack_public_path__ + "locales/tr/DowngradePlanDialog.json?hash=90896703c062a0a82b7db1eb6b0332a4";